export const containerDefaultProps = {
  type: 'outlined'
};